import { useEffect } from 'react';
import { hideWindow } from '../api/agent';
import { SelfServiceContainer } from './containers/SelfService';
import AppShell from '../common/AppShell/AppShell';

const SelfService = () => {
  useEffect(() => {
    window.addEventListener('beforeunload', hideWindow);

    return () => {
      window.removeEventListener('beforeunload', hideWindow);
    };
  }, []);

  return (
    <AppShell translationRoot="self-service">
      <SelfServiceContainer />
    </AppShell>
  );
};

export default SelfService;
